<template>
  <div class="overflow">
    <div v-if="element.field_type === 'image' && element.value.length > 0">
      <img
        :src="fetchImage(element.value[0].url, 1024, 900)"
        class="image mb-2"
      >
    </div>
    <gallery-section
      v-else-if="element.field_type === 'multi_image'"
      :element="element"
    />
    <div
      v-else-if="element.field_type === 'text'"
      class="mb-2 custom-html-image custom-html-text"
      v-html="element.value"
    />
    <div
      v-else-if="element.field_type === 'string'"
      class="lyon-display-medium-32 text-align-left mb-3 custom-html-text"
      v-html="element.value"
    />
    <accordion-view-section
      v-else-if="element.field_type === 'accordion'"
      :accordion-list="element.accordionList"
      :accordion-width="element.accordion_width"
    />
  </div>
</template>

<script>
import AccordionViewSection from '@/components/CommonPages/AccordionViewSection.vue'
import mixin from '@/utils/mixin.js'

export default {
  name: 'CustomViewSection',
  components: {
    GallerySection: () => import('./GallerySection.vue'),
    AccordionViewSection
  },
  mixins: [mixin],
  props: ['element', 'quickLinkList'],
}
</script>

<style lang="scss" scoped>
.overflow {
  overflow-x: auto;
}
.image {
  //max-height: 500px;
  //max-width: 100%;
  max-height: auto;
  max-width: 100%;
  width: 100%;
  height: auto;

  @media (max-width: 64rem) {
    max-height: none !important;
    max-width: 100%;
  }
}
.desktop-block {
  display: block !important;
  @media (max-width: 64rem) {
    display: none !important;
  }
}
</style>
